module.exports = __webpack_public_path__ + "img/icon-sports-yellow.a4d304f2.svg";